import React from 'react';
import { ArrowRight, Bot, Zap, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-blue-50 pt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="space-y-6 sm:space-y-8">
            {/* Icon decoration */}
            <div className="flex justify-center items-center space-x-4 mb-8">
              <div className="p-4 bg-blue-100 rounded-2xl">
                <Bot className="w-12 h-12 text-blue-600" />
              </div>
              <div className="p-4 bg-[#FFD700]/20 rounded-2xl">
                <Zap className="w-12 h-12 text-[#FFD700]" />
              </div>
              <div className="p-4 bg-blue-100 rounded-2xl">
                <TrendingUp className="w-12 h-12 text-blue-600" />
              </div>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              AI чат-бот который
              <span className="block text-blue-600 mt-2">продает за вас 24/7</span>
            </h1>
            
            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Не просто отвечает на вопросы — консультирует, продает, запоминает данные о клиентах и запускает умные рассылки. 
              <span className="block mt-2 font-semibold text-gray-900">Ваш личный менеджер по продажам, который никогда не спит.</span>
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                onClick={() => scrollToSection('cta')} 
                className="bg-[#FFD700] hover:bg-[#E5C200] text-gray-900 font-bold text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
              >
                Получить демо
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button 
                onClick={() => scrollToSection('services')} 
                variant="outline" 
                className="border-2 border-gray-300 hover:border-blue-600 hover:bg-blue-50 font-semibold text-lg px-8 py-6 transition-all"
              >
                Как это работает
              </Button>
            </div>

            <div className="flex flex-wrap gap-8 pt-8 justify-center">
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <div className="text-3xl font-bold text-gray-900">24/7</div>
                <div className="text-sm text-gray-600">Работает без перерывов</div>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <div className="text-3xl font-bold text-gray-900">∞</div>
                <div className="text-sm text-gray-600">Клиентов одновременно</div>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <div className="text-3xl font-bold text-gray-900">3x</div>
                <div className="text-sm text-gray-600">Рост конверсии</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
